import { createContext, useContext } from 'react';
import type { MeAdminOrg } from '@/api/orgAdmin';

/**
 * EAA-1797 (P4b): the console's acting-organization context.
 *
 * Split from the provider component (`actingOrg.tsx`) so this module exports only
 * hooks/values — keeps react-refresh happy, same split as the console-capability
 * context.
 */
export interface ActingOrgValue {
    organizations: MeAdminOrg[];
    actingOrgId: string | null;
    actingOrg: MeAdminOrg | null;
    setActingOrg: (orgId: string) => void;
    /** True when the caller administers 2+ orgs — the picker only renders then. */
    canSwitch: boolean;
}

export const ActingOrgContext = createContext<ActingOrgValue | null>(null);

/**
 * The acting-org context, or `null` outside the console. AppBar is shared across
 * pages that have no provider (launcher, profile), so consumers must tolerate null.
 */
export function useActingOrg(): ActingOrgValue | null {
    return useContext(ActingOrgContext);
}
